import React, { useState } from "react";
import PropTypes from "prop-types";
import DataSourceDeleteModal from "./DataSourceDeleteModal";
import DataSourceUpdateModal from "./DataSourceUpdateModal";
import DataSourceActiveButton from "./DataSourceActiveButton";

function DataSourceCard({ savedsource, setConductReload }) {
  const imageSrc = `${savedsource.source.icon_url}`;

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleUpdateClick = () => {
    setShowUpdateModal(true);
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const truncateName = (name, maxLength = 20) => {
    return name.length > maxLength ? `${name.substring(0, maxLength)}...` : name;
  };

  return (
    <>
      <div key={savedsource.id} className="w-full md:w-1/3 px-2 mb-4">
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow border-0">
          <div className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h5 className="text-lg font-bold text-left mb-2 text-gray-900 dark:text-white" title={savedsource.name}>
                  {truncateName(savedsource.name)}
                </h5>
              </div>
              <div className="ml-auto">
                <img
                  src={imageSrc}
                  height="40"
                  className="rounded"
                  alt={`${savedsource.name} Logo`}
                />
              </div>
            </div>
            <div className="flex justify-between mt-3">
              <DataSourceActiveButton
                savedsource={savedsource}
              />
              <div className="flex gap-2">
                <button
                  type="button"
                  className="px-3 py-1 text-sm border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
                  onClick={handleUpdateClick}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
                  onClick={handleDeleteClick}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showUpdateModal && (
        <DataSourceUpdateModal
          savedsource={savedsource}
          showUpdateModal={showUpdateModal}
          setShowUpdateModal={setShowUpdateModal}
          setConductReload={setConductReload}
        />
      )}

      {showDeleteModal && (
        <DataSourceDeleteModal
          savedsource={savedsource}
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          setConductReload={setConductReload}
        />
      )}
    </>
  );
}

DataSourceCard.propTypes = {
  savedsource: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    source: PropTypes.shape({
      icon_url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  setConductReload: PropTypes.func.isRequired,
};

export default DataSourceCard;
